import axios from 'axios'
import { Conflict } from '@src/data/types/Conflict'

// No need to overcomplicate default api client configurations via redux and instances
// Axios is already a singleton and can be used as is
axios.defaults.baseURL = import.meta.env.VITE_BACKOFFICE_API_URL
axios.defaults.headers['X-requestor'] = `backofficeapp:${import.meta.env.VITE_VERSION}`

// Callback for reporting conflicts (409 errors) - set by AppConfigProvider
let reportConflict: ((conflict: Conflict) => void) | null = null

export const setReportConflict = (callback: typeof reportConflict) => {
  reportConflict = callback
}

// Response interceptor to handle 409 Conflict errors
axios.interceptors.response.use(
  (response) => response,
  (error: Error) => {
    if (axios.isAxiosError(error) && error.response?.status === 409) {
      const conflictData = error.response.data as Conflict | undefined
      if (conflictData && reportConflict) {
        reportConflict({
          userId: conflictData.userId,
          userFullName: conflictData.userFullName,
          updatedOn: conflictData.updatedOn,
        })
      }
    }
    return Promise.reject(error)
  },
)

export const setApiClientAuthorization = (token: string) => {
  axios.defaults.headers.Authorization = `Bearer ${token}`
}

export const getApiClient = () => {
  return axios
}
export default axios
